(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('MeasurementUnitSearch', MeasurementUnitSearch);

    MeasurementUnitSearch.$inject = ['$resource'];

    function MeasurementUnitSearch($resource) {
        var resourceUrl =  'api/_search/measurement-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
